import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './bloqueioBaseForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, salvar, excluir, getLista
} from './bloqueioBaseActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import consts from '../consts';

class BloqueioBase extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
	}
	
	componentWillUnmount() {
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
	
		return (
			<ContentCard>
				<ContentCardHeader>

					<style>{`
						.unidades-header {
							display: flex;
							align-items: center;
							margin-bottom: 18px;
						}

						.unidades-header-titulo {
							display: flex;
							align-items: center;
							gap: 14px;
						}

						.unidades-header-titulo i {
							width: 46px;
							height: 46px;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 12px;
							background: linear-gradient(135deg,#eef3fb,#dfe8f8);
							color: #1f3269;
							font-size: 18px;
						}

						.unidades-header-titulo strong {
							display: block;
							font-size: 18px;
							color: #2b3545;
						}

						.unidades-header-titulo span {
							display: block;
							margin-top: 3px;
							font-size: 12px;
							color: #8c97a7;
						}

						.unidade-card {
							background: #fff;
							border-radius: 14px;
							padding: 18px;
							margin-bottom: 18px;
							border: 1px solid #e8edf4;
							box-shadow: 0 4px 14px rgba(0,0,0,.05);
							transition: .2s;
							height: 170px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
						}

						.unidade-card:hover {
							transform: translateY(-3px);
							box-shadow: 0 8px 20px rgba(0,0,0,.08);
						}

						.unidade-card.liberada {
							border-left: 5px solid #28a745;
						}

						.unidade-card.bloqueada {
							border-left: 5px solid #dc3545;
						}

						.unidade-topo {
							display: flex;
							align-items: center;
							gap: 14px;
						}

						.unidade-icone {
							width: 46px;
							height: 46px;
							border-radius: 12px;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 18px;
							background: #eef2f7;
						}

						.unidade-card.liberada .unidade-icone {
							color: #28a745;
							background: #e9f8ef;
						}

						.unidade-card.bloqueada .unidade-icone {
							color: #dc3545;
							background: #fdeced;
						}

						.unidade-nome {
							font-size: 15px;
							font-weight: 700;
							color: #2f3747;
							line-height: 1.3;
						}

						.unidade-status {
							display: inline-block;
							margin-top: 6px;
							padding: 4px 10px;
							border-radius: 20px;
							font-size: 11px;
							font-weight: 700;
						}

						.unidade-card.liberada .unidade-status {
							background: #e9f8ef;
							color: #23904d;
						}

						.unidade-card.bloqueada .unidade-status {
							background: #fdeced;
							color: #d63e4f;
						}

						.unidade-botao {
							margin-top: 18px;
						}

						.unidade-botao button {
							width: 100%;
						}
					`}</style>

					<div className="unidades-header">

						<div className="unidades-header-titulo">
							<i className="fas fa-building"></i>

							<div>
								<strong>Controle das Unidades</strong>
								<span>Gerencie rapidamente o bloqueio e liberação das unidades.</span>
							</div>
						</div>

					</div>

					<Row>

						{this.props.listaUnidades.map(unidade => {

							const registro = (this.props.lista || []).find(
								item =>
									item.id_unidade == unidade.id &&
									!item.datahora_termino
							);

							const bloqueada = !!registro;

							return (
								<Grid
									key={unidade.id}
									cols="12 6 4 3"
								>

									<div className={`unidade-card ${bloqueada ? 'bloqueada' : 'liberada'}`}>

										<div className="unidade-topo">

											<div className="unidade-icone">
												<i className={`fas ${bloqueada ? 'fa-lock' : 'fa-lock-open'}`}></i>
											</div>

											<div>

												<div className="unidade-nome">
													{unidade.nome}
												</div>

												<div className="unidade-status">
													{bloqueada ? 'Bloqueada' : 'Liberada'}
												</div>

											</div>

										</div>

										<div className="unidade-botao">

											{bloqueada ? (

												<Button
													text="Liberar Unidade"
													type="success"
													icon="fas fa-lock-open"
													event={() => {
														this.props.salvar({
															...registro
														});
													}}
												/>

											) : (

												<Button
													text="Bloquear Unidade"
													type="danger"
													icon="fas fa-lock"
													event={() => {
														this.props.salvar({
															id_unidade: unidade.id
														});
													}}
												/>

											)}

										</div>

									</div>

								</Grid>
							);

						})}

					</Row>

				</ContentCardHeader>

				<ContentCardBody>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th rowspan={2} alignCenter>Unidade</Th>
								<Th colspan={2} alignCenter>Bloqueio</Th>
								<Th colspan={2} alignCenter>Liberação</Th>
							</Tr>
							<Tr>
						 		<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Usuário</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Usuário</Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`
										${item.nome_unidade}
										${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}
										${item.nome_usuario_inicio}
										${DateFormat.formatarDataHoraSqlParaTela(item.datahora_termino)}
										${item.nome_usuario_termino}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{item.nome_unidade}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}</Td>
									<Td alignCenter>{item.nome_usuario_inicio}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_termino)}</Td>
									<Td alignCenter>{item.nome_usuario_termino}</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.bloqueioBase,
	modoTela: state.bloqueioBase.modoTela,
	lista: state.bloqueioBase.lista,
	listaUnidades: state.bloqueioBase.listaUnidades
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(BloqueioBase);
